import type { SearchContextType } from '@gat-ship/types'

export interface RecentSearch {
  searchString: string
  context: SearchContextType
  timestamp: number
}

/**
 * Prepends `incoming` to the history, dropping any earlier entry with the
 * same `(searchString, context)` pair, then caps the list at `max`
 * (newest first). Pure: returns a fresh array, never mutates `items`.
 */
export function dedupeRecentSearches(
  items: readonly RecentSearch[],
  incoming: RecentSearch,
  max: number
): RecentSearch[] {
  const deduped = items.filter(
    (item) =>
      !(
        item.context === incoming.context &&
        item.searchString === incoming.searchString
      )
  )
  return [incoming, ...deduped].slice(0, max)
}

/** Returns the first `max` recent searches (newest first). */
export function takeRecentSearches(
  items: readonly RecentSearch[],
  max: number
): RecentSearch[] {
  return items.slice(0, max)
}
